import React, { useState } from 'react'
import { Box, Paper } from '@mui/material';
import { ActivityIndicator, ButtonCus, SelectCus } from 'components';
import useMode from 'hooks/useMode';
import DownloadExcelOptions from './DownloadExcelOptions';
import moment from 'moment';
import aiAxios from 'services/aiAxios';
import { downloadpng, Icons } from 'assets';
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useBDS } from 'hooks';

//全て
const statusOtps = [
    { id: "", name: '全部' },
    { id: "0", name: '先月残掲載物件' },
    { id: "1", name: '成約物件' },
    { id: "2", name: '新着物件' },
]


export default function FilterBar({ wardSales, onChangeStatus }) {
    const mode = useMode()
    const { onUpdateToday } = useBDS()
    // const [value, setValue] = React.useState<any>({
    //     start: 0,
    //     end: 0
    // });

    const [state, setState] = useState<any>({});
    const [loadingDownload, setLoadingDownload] = useState<any>(false);

    const handleUpdateToday = async () => {
        setState({ updateToday: true })
        onUpdateToday(rs => {
            setState({ updateToday: false })
        })
    }

    const handleActionBtnDownload = (action: string) => (e?: unknown) => {
        if (action === 'showDownload')
            return setState(old => ({
                ...old,
                anchorDownloadPop: (e as React.MouseEvent<HTMLButtonElement>)?.currentTarget,
            }));
    };

    const handleDownload = async (type: string) => {
        setLoadingDownload(true)
        console.log("🚀 ~ handleDownload ~ type:", type)
        if (!['house', 'apartment'].includes(type)) return;
        try {
            const fileName = `detail_${type}_${moment().format("YYYYMMDD")}.xlsx`
            // const fileName = 'detail_apartment_05_05_2025.xlsx'
            const response = await aiAxios.get(`/download/${type}`, {
                responseType: 'blob'
            })
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setLoadingDownload(false);

        } catch (error) {
            setLoadingDownload(false)
        }

    }

    return (
        <Paper sx={{ p: 2, mb: 3, minHeight: 54, borderTop: `2px solid ${mode.primary}` }}>
            <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
                {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['DatePicker']}>
                        <DatePicker
                            label="Start"
                            onChange={(newValue) => handlePick(newValue)('start')}
                        // defaultValue={dayjs(moment.now())}
                        />
                        <DatePicker
                            label="End"
                            onChange={(newValue) => handlePick(newValue)('end')}
                        // defaultValue={dayjs(moment.now())}
                        />
                    </DemoContainer>
                </LocalizationProvider> */}
                <Box minWidth={70} ml={3}>
                    <SelectCus
                        // isShowLabel
                        label='絞り込み'
                        options={statusOtps}
                        sx={{ minWidth: 200 }}
                        onChange={e => onChangeStatus(e.target.value)}
                    />
                </Box>
                <Box flex={1} />

                <Box display={'flex'} flexDirection={'row'} justifyContent={'flex-end'}>
                    {/* <ButtonCus sx={{ ml: 5 }}> 毎月5日 </ButtonCus> */}
                    <Box minWidth={70} ml={3}>
                        {/* <FormLabel><TextCus>絞り込み</TextCus></FormLabel> */}
                        <SelectCus
                            // isShowLabel
                            options={wardSales}
                            label='地域'
                            value={''}
                            sx={{ minWidth: 200 }}
                            onChange={(e) => { }}
                        />
                    </Box>

                    <Box onClick={(e) => handleActionBtnDownload('showDownload')(e)} sx={{ ml: 5 }}>
                        <ButtonCus
                            variant="contained"
                            size="small"
                            startIcon={
                                <Box display={'flex'} flexDirection={'row'}>
                                    {loadingDownload && <ActivityIndicator color={mode.secondary} style={{ marginRight: 5 }} />}
                                    <LazyLoadImage
                                        src={downloadpng}
                                        alt="logo"
                                        effect="blur"
                                        height={"32px"}
                                    />
                                </Box>
                            }
                        >
                            ダウンロード
                        </ButtonCus>
                    </Box>
                    <Box onClick={(e) => handleUpdateToday()} sx={{ ml: 5 }}>
                        <ButtonCus
                            variant="contained"
                            size="small"
                            startIcon={
                                <Box display={'flex'} flexDirection={'row'}>
                                    {!!state.updateToday && <ActivityIndicator color={mode.secondary} style={{ marginRight: 5 }} />}
                                </Box>
                            }
                        >
                            <Box display={'flex'} flexDirection={'row'}>
                                {Icons.Email()} メールを送信
                            </Box>
                        </ButtonCus>
                    </Box>
                </Box>
            </Box>
            <DownloadExcelOptions
                isOpen={state.anchorDownloadPop || null}
                onClose={handleActionBtnDownload('showDownload')}
                onConfirm={handleDownload}
            />
        </Paper>
    )
}
